import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createVNode("a", {
  id: "downloadAnchor",
  style: {"display":"none"}
}, null, -1)
const _hoisted_3 = {
  ref: "imageContainer",
  style: {"display":"none"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: "images/error.svg",
  crossorigin: "anonymous",
  id: "broken_TAKEN_ID"
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_header = _resolveComponent("app-header")
  const _component_component_tree = _resolveComponent("component-tree")
  const _component_my_canvas = _resolveComponent("my-canvas")
  const _component_toolbar = _resolveComponent("toolbar")
  const _component_side_bar = _resolveComponent("side-bar")
  const _component_project_explorer = _resolveComponent("project-explorer")
  const _component_loading_screen = _resolveComponent("loading-screen")
  const _component_license_prompt = _resolveComponent("license-prompt")
  const _component_sync_prompt = _resolveComponent("sync-prompt")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.projectExplorerOpen)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_app_header),
          _createVNode("div", {
            class: "row mainSpace",
            onClickCapture: _cache[2] || (_cache[2] = (...args) => (_ctx.updateHistory(...args)))
          }, [
            _createVNode(_component_component_tree),
            _createVNode("div", {
              class: "canvasContainer",
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.selection = null), ["self"]))
            }, [
              _createVNode(_component_my_canvas),
              _createVNode(_component_toolbar)
            ]),
            _createVNode(_component_side_bar)
          ], 32)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(_component_project_explorer, { key: 1 })),
    _createVNode(_component_loading_screen),
    _createVNode(_component_license_prompt),
    _createVNode(_component_sync_prompt),
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4
    ], 512)
  ]))
}